import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '@/components/Seo';

export default function NotFoundPage() {
  return (
    <>
      <Seo title="Page not found" description="The page you were looking for doesn’t exist." noindex />
      <section className="container-x py-24 text-center max-w-xl mx-auto">
        <span className="eyebrow">404</span>
        <h1 className="font-display text-4xl md:text-5xl font-bold mt-4">We couldn’t find that page.</h1>
        <p className="text-[color:var(--ft-muted)] mt-4">It may have moved or never existed. Try one of these instead:</p>
        <div className="grid grid-cols-2 gap-3 mt-7 max-w-md mx-auto">
          <Link to="/" className="btn btn-primary">Home</Link>
          <Link to="/services" className="btn btn-secondary">Services</Link>
          <Link to="/contact" className="btn btn-secondary">Contact</Link>
          <Link to="/locations" className="btn btn-secondary">Locations</Link>
        </div>
      </section>
    </>
  );
}
